/**
 * kumpulan state pada root Store
 */
// const jwtName = process.env.VUE_APP_JWT_NAME

const state = {
  // page title
  pageTitle: '',

  // progress bar
  progressBar: false,

  // alert
  alertBox: false,
  alertMessage: '',
  alertColor: 'info',

  // drawer
  drawer: false,
  drawerContent: null,
  drawerColor: null,

  // authen  
  auth: {
    token: '',
    isLogin: false,
    userInfo: {},
    userHome: ''
  },  

  //tahunAnggaran
  tahunAnggaran: new Date().getFullYear(),

  // rules
  rules: [
    {
      key: 'MASA_BERLAKU_SIUP',
      value: 60
    },
    {
      key: 'PANJANG_MIN_LOGIN',
      value: 5
    },
    {
      key: 'PANJANG_MIN_PASSWD',
      value: 5
    }
  ]
}

export default state